import * as Dialog from '@radix-ui/react-dialog';
import { useMedia } from 'react-use';

import { useFiatDisplay } from '@/hooks/useFiatDisplay';
import { LiquiditySource } from '@/hooks/useSourcesAll';

import { dialogCloseBtnStyles } from '@/styles/dialog';
import { fontStyles } from '@/styles/typography';
import { breakpoints } from '@/styles/util';

import { XIcon } from '@/ui/Icons/XIcon';
import { Modal } from '@/ui/Modal';
import { BottomPanelModal } from '@/ui/Modal/BottomPanelModal';

import { abbreviateNumber } from '@/utils/numbers';

import { LiquiditySourceChains } from '../LiquiditySourcesTable/LiquiditySourceRow';

export function LiquiditySourcesModal({
  isOpen,
  onClose,
  onOpenChange,
  selectedSource,
}: {
  isOpen: boolean;
  onClose: () => void;
  onOpenChange: () => void;
  selectedSource: LiquiditySource;
}) {
  const { formatFiat } = useFiatDisplay();
  const { liquiditySource, transactions, volume, volume30D, chains } = selectedSource;

  const isMobile = useMedia(breakpoints.mobile, false);

  const content = (
    <>
      <div className="px-6 pt-[22px] pb-[14px] items-center flex justify-between">
        <Dialog.Title className={fontStyles({ variant: 'H5' })}>{liquiditySource}</Dialog.Title>

        <Dialog.Close className={dialogCloseBtnStyles().button({})}>
          <XIcon aria-hidden className={dialogCloseBtnStyles().icon()} />
        </Dialog.Close>
      </div>
      <ul className="px-6 pb-2 mb-16 tablet:mb-0">
        <li className="flex justify-between items-center h-11 border-t border-solid border-token-gray-300 text-token-gray-1600 text-sm">
          <span className="text-token-gray-800">Total Volume</span>
          <span>{formatFiat(volume)}</span>
        </li>
        <li className="flex justify-between items-center h-11 border-t border-solid border-token-gray-300 text-token-gray-1600 text-sm">
          <span className="text-token-gray-800">Volume (30 D)</span>
          <span>{formatFiat(volume30D)}</span>
        </li>
        <li className="flex justify-between items-center h-11 border-t border-solid border-token-gray-300 text-token-gray-1600 text-sm">
          <span className="text-token-gray-800"># Trades (30 D)</span>
          <span>{abbreviateNumber(transactions)}</span>
        </li>
        <li className="flex justify-between items-center h-11 border-t border-solid border-token-gray-300 text-token-gray-1600 text-sm">
          <span className="text-token-gray-800"># Networks</span>
          <div className="p-[6px] pr-3 rounded-[900px] border border-solid border-token-gray-1300">
            <LiquiditySourceChains chains={chains} />
          </div>
        </li>
      </ul>
    </>
  );

  return isMobile ? (
    <BottomPanelModal isOpen={isOpen} onClose={onClose} onOpenChange={onOpenChange} variant="LARGE">
      {content}
    </BottomPanelModal>
  ) : (
    <Modal isOpen={isOpen} onClose={onClose} onOpenChange={onOpenChange} variant="LARGE">
      {content}
    </Modal>
  );
}
